import { render, staticRenderFns } from "./WonderAiReportDetail.vue?vue&type=template&id=2c6e652e&scoped=true"
import script from "./WonderAiReportDetail.vue?vue&type=script&lang=js"
export * from "./WonderAiReportDetail.vue?vue&type=script&lang=js"
import style0 from "./WonderAiReportDetail.vue?vue&type=style&index=0&id=2c6e652e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6e652e",
  null
  
)

export default component.exports